(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-group-end"] && !Shopify.designMode) return;
  try {
    
  /**
   * Section Group End Component
   * Marks the end of a gradient group
   */
  class SectionGroupEnd extends HTMLElement {
    connectedCallback() {
      const wrapper = this.closest('.shopify-section');
      if (wrapper) {
        wrapper.setAttribute('data-section-group-end', '');
      }
    }
  }

  if (!customElements.get('section-group-end')) {
    customElements.define('section-group-end', SectionGroupEnd);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-group-settings"] && !Shopify.designMode) return;
  try {
    
  /**
   * Section Group Settings Component
   * Creates a continuous gradient by calculating each section's position
   * and applying background-position offsets for seamless continuity.
   */
  class SectionGroupSettings extends HTMLElement {
    connectedCallback() {
      // Wait for DOM to be fully ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        // Use setTimeout to ensure all sections are rendered
        setTimeout(() => this.init(), 100);
      }
    }

    // Converts solid colors to gradients for background-image compatibility
    normalizeGradient(value) {
      if (!value) return '';
      // If it's already a gradient, return as-is
      if (value.includes('gradient')) return value;
      // Wrap solid colors in a linear-gradient
      return `linear-gradient(0deg, ${value}, ${value})`;
    }

    init() {
      this.wrapper = this.closest('.shopify-section');
      if (!this.wrapper) return;

      this.bgGradient = this.normalizeGradient(this.dataset.bgGradient || '');
      this.textGradient = this.normalizeGradient(this.dataset.textGradient || '');
      this.bgGradientEnabled = this.dataset.bgGradientEnabled === 'true';
      this.textGradientEnabled = this.dataset.textGradientEnabled === 'true';

      // Mark this as a group start
      this.wrapper.setAttribute('data-section-group-start', '');

      // Find all sections in this group (until end marker)
      this.groupedSections = this.findGroupedSections();

      if (this.groupedSections.length > 0) {
        this.applyGradients();

        // Re-calculate on resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => this.applyGradients(), 100);
        });
      }
    }

    findGroupedSections() {
      const sections = [];
      let nextSection = this.wrapper.nextElementSibling;

      while (nextSection) {
        if (nextSection.classList.contains('shopify-section')) {
          // Stop if we encounter an end marker or another group start
          if (nextSection.querySelector('section-group-end') ||
              nextSection.hasAttribute('data-section-group-end') ||
              nextSection.querySelector('section-group-settings')) {
            break;
          }
          sections.push(nextSection);
        }
        nextSection = nextSection.nextElementSibling;
      }

      return sections;
    }

    applyGradients() {
      // Calculate total height of all grouped sections
      let totalHeight = 0;
      const sectionHeights = [];

      this.groupedSections.forEach(section => {
        const height = section.offsetHeight;
        sectionHeights.push({ section, height, offset: totalHeight });
        totalHeight += height;
      });

      // Apply gradient to each section with correct positioning
      sectionHeights.forEach(({ section, height, offset }) => {
        // Check if section has its own gradient (don't override)
        const sectionBg = section.querySelector('.section-background');
        const hasOwnGradient = sectionBg &&
          sectionBg.getAttribute('style')?.includes('background-image') &&
          !sectionBg.getAttribute('style')?.includes('var(--group-gradient)');

        if (hasOwnGradient) {
          section.setAttribute('data-has-own-gradient', '');
          return;
        }

        // Apply background gradient
        if (this.bgGradientEnabled && this.bgGradient) {
          section.setAttribute('data-in-gradient-group', '');
          section.style.setProperty('--group-gradient', this.bgGradient);
          section.style.setProperty('--group-total-height', `${totalHeight}px`);
          section.style.setProperty('--group-offset', `-${offset}px`);
        }

        // Apply text gradient
        if (this.textGradientEnabled && this.textGradient) {
          section.setAttribute('data-in-text-gradient-group', '');
          section.style.setProperty('--group-text-gradient', this.textGradient);
        }
      });
    }
  }

  if (!customElements.get('section-group-settings')) {
    customElements.define('section-group-settings', SectionGroupSettings);
  }

  } catch(e) { console.error(e); }
})();
})();
